/**
 * Helper function to normalize key string identifiers.
 * @module keyboard/normalize
 */

import { Keys } from './keys';

/**
 * Normalizes keys for convenience.
 *
 * @param {string} key The key that should be normalized.
 * @return {string} A normalized representation of the requested key.
 */
export function normalizeKey(key) {
    switch (key) {
        case 'Down':
        case 'ArrowDown':
            return Keys.DOWN;
        case 'Left':
        case 'ArrowLeft':
            return Keys.LEFT;
        case 'Right':
        case 'ArrowRight':
            return Keys.RIGHT;
        case 'Up':
        case 'ArrowUp':
            return Keys.UP;
        case 'Enter':
            return Keys.ENTER;
        case 'Esc':
        case 'Escape':
            return Keys.ESCAPE;
        case 'Spacebar':
        case ' ':
            return Keys.SPACE;
        case 'Tab':
            return Keys.TAB;
        case 'Backspace':
            return Keys.BACKSPACE;
        case 'Shift':
            return Keys.SHIFT;
        case 'End':
            return Keys.END;
        case 'Home':
            return Keys.HOME;
        case 'PageDown':
            return Keys.PAGEDOWN;
        case 'PageUp':
            return Keys.PAGEUP;

        default:
            return key;
    }
}
